import { render, staticRenderFns } from "./CloudWarehouse.vue?vue&type=template&id=47cc14e6&"
import script from "./CloudWarehouse.vue?vue&type=script&lang=js&"
export * from "./CloudWarehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports